import { render } from "./vacancy.vue?vue&type=template&id=b7056b9a&scoped=true"
import script from "./vacancy.vue?vue&type=script&lang=js"
export * from "./vacancy.vue?vue&type=script&lang=js"

import "./vacancy.vue?vue&type=style&index=0&id=b7056b9a&lang=scss&scoped=true"
import "./vacancy.vue?vue&type=style&index=1&id=b7056b9a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7056b9a"]])

export default __exports__